import { combineReducers } from 'redux'
import dashboard from './reducers/dashboard'
import activity from './reducers/activity'

const rootReducer = combineReducers({
  dashboard,
  activity,
})

export default rootReducer
